import BaseOption from "%/dynamic-component-editor/classes/base-option";

export default class BaseOptionsBundle {

  static optionClassName = "";
  static userInterfaceComponent = null;

  optionTitle = "";
  inspectorToolGroup = "";
  useInspectorLabel = true;
  _options = [];
  isOverridable = true;

  constructor(values = {}, optionClasses = []) {
    let userInterfaceComponent = this.constructor.userInterfaceComponent;
    if (userInterfaceComponent) {
      BaseOption.assertValidInterfaceComponent(userInterfaceComponent);
    }

    this._options = optionClasses;
    this._initializeOptionsWithValues(values);
  }

  get title() {
    return this.optionTitle;
  }

  get options() {
    return this._options;
  }

  get userInterfaceComponent() {
    return this.constructor.userInterfaceComponent;
  }

  static get className() {
    return this.optionClassName;
  }

  _initializeOptionsWithValues(options) {
    this._options = this._options.map(OptionClass => {
      const instance = typeof OptionClass === "function" ? new OptionClass() : OptionClass;
      const result = {};

      Object.values(BaseOption.$states).forEach(state => {
        const stateKey = `${state}.${instance.optionKey}`;
        const defaultStateKey = `${BaseOption.$states.DEFAULT}.${instance.optionKey}`;
        const declared = options || {};
        if (Object.prototype.hasOwnProperty.call(declared, stateKey)) {
          result[state] = declared[stateKey];
          return;
        }
        if (Object.prototype.hasOwnProperty.call(declared, defaultStateKey)) {
          result[state] = declared[defaultStateKey];
          return;
        }
        result[state] = instance.getValueOrDefault()[stateKey];
      });

      if (typeof OptionClass === "function") {
        return new OptionClass(result);
      } else {
        OptionClass.stateValues = result;
        return OptionClass;
      }
    });
  }
}
